import React, { useState, useEffect } from 'react';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {object, func, bool, string} from 'prop-types';
import {CloneObject, GetMeses} from '../../../utils/helpers';
import { Accordion, CheckboxButton, CheckboxButtonGroup, DatePickerCustom, FormError, FormLabel, InputEjercicio, InputEntidad, InputExpediente, InputLista, InputPercent, Select } from '../../common';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {useEntidad} from '../../hooks/useEntidad';
import {TIPS} from "../../../consts/tips";
import Modal from '../../common/Modal';

import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const InspeccionModal = (props) => {
    const entityInit = {
        id: 0,
        idComercio: 0,
        numero: '',
        idMotivoInspeccion: 0,
        idSupervisor: 0,
        idInspector: 0,
        fechaInicio: null,
        fechaFinalizacion: null,
        fechaNotificacion: null,
        fechaBaja: null,
        anioDesde: '',
        mesDesde: 0,
        anioHasta: '',
        mesHasta: 0,
        numeroResolucion: '',
        letraResolucion: '',
        anioResolucion: '',
        fechaResolucion: null,
        numeroLegajillo: '',
        letraLegajillo: '',
        anioLegajillo: '',
        activo: '',
        porcentajeMulta: 0,
        emiteConstancia: '',
        pagaPorcentaje: false,
        idExpediente: 0,
        detalleExpediente: ''
    };

    const [state, setState] = useState({
        entity: entityInit
    });

    const [expediente, setExpediente] = useState({
        detalleExpediente: ""
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            numero: props.data.entity.numero,
            idMotivoInspeccion: props.data.entity.idMotivoInspeccion,
            idSupervisor: props.data.entity.idSupervisor,
            idInspector: props.data.entity.idInspector,
            fechaInicio: props.data.entity.fechaInicio,
            fechaFinalizacion: props.data.entity.fechaFinalizacion,
            fechaNotificacion: props.data.entity.fechaNotificacion,
            fechaBaja: props.data.entity.fechaBaja,
            anioDesde: props.data.entity.anioDesde,
            mesDesde: parseInt(props.data.entity.mesDesde),
            anioHasta: props.data.entity.anioHasta,
            mesHasta: parseInt(props.data.entity.mesHasta),
            numeroResolucion: props.data.entity.numeroResolucion,
            letraResolucion: props.data.entity.letraResolucion,
            anioResolucion: props.data.entity.anioResolucion,
            fechaResolucion: props.data.entity.fechaResolucion,
            numeroLegajillo: props.data.entity.numeroLegajillo,
            letraLegajillo: props.data.entity.letraLegajillo,
            anioLegajillo: props.data.entity.anioLegajillo,
            activo: props.data.entity.activo,
            porcentajeMulta: props.data.entity.porcentajeMulta,
            emiteConstancia: props.data.entity.emiteConstancia,
            pagaPorcentaje: props.data.entity.pagaPorcentaje,
            idExpediente: props.data.entity.idExpediente
        });
        setExpediente({
            detalleExpediente: props.data.entity.detalleExpediente
        });
    }
    useEffect(mount, [props.data.entity]);

    const [, getRowTipoControlador] = useEntidad({
        entidades: ['TipoControlador'],
        onLoaded: (entidades, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoControlador',
            timeout: 0
        }
    });

    const [formValues, formHandle, , formSet] = useForm({
        numero: '',
        idMotivoInspeccion: 0,
        idSupervisor: 0,
        idInspector: 0,
        fechaInicio: null,
        fechaFinalizacion: null,
        fechaNotificacion: null,
        fechaBaja: null,
        anioDesde: '',
        mesDesde: 0,
        anioHasta: '',
        mesHasta: 0,
        numeroResolucion: '',
        letraResolucion: '',
        anioResolucion: '',
        fechaResolucion: null,
        numeroLegajillo: '',
        letraLegajillo: '',
        anioLegajillo: '',
        activo: '',
        porcentajeMulta: 0,
        emiteConstancia: '',
        pagaPorcentaje: false,
        idExpediente: 0,
    });

    const [datosOpen, setDatosOpen] = useState(true);
    const [expedienteOpen, setExpedienteOpen] = useState(false);

    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickAceptar = () => {
        const errors = getErrors();
        if (Object.keys(errors).some(key => key !== 'idExpediente')) setDatosOpen(true);
        if (errors.idExpediente) setExpedienteOpen(true);

        if (validate()) {
            let row = CloneObject(state.entity);
            row.numero = formValues.numero;
            row.idMotivoInspeccion = parseInt(formValues.idMotivoInspeccion);
            row.idSupervisor = parseInt(formValues.idSupervisor);
            row.idInspector = parseInt(formValues.idInspector);
            row.fechaInicio = formValues.fechaInicio;
            row.fechaFinalizacion = formValues.fechaFinalizacion;
            row.fechaNotificacion = formValues.fechaNotificacion;
            row.fechaBaja = formValues.fechaBaja;
            row.anioDesde = formValues.anioDesde;
            row.mesDesde = formValues.mesDesde.toString();
            row.anioHasta = formValues.anioHasta;
            row.mesHasta = formValues.mesHasta.toString();
            row.numeroResolucion = formValues.numeroResolucion;
            row.letraResolucion = formValues.letraResolucion;
            row.anioResolucion = formValues.anioResolucion;
            row.fechaResolucion = formValues.fechaResolucion;
            row.numeroLegajillo = formValues.numeroLegajillo;
            row.letraLegajillo = formValues.letraLegajillo;
            row.anioLegajillo = formValues.anioLegajillo;
            row.activo = formValues.activo;
            row.porcentajeMulta = formValues.porcentajeMulta;
            row.emiteConstancia = formValues.emiteConstancia;
            row.pagaPorcentaje = formValues.pagaPorcentaje;
            row.idExpediente = parseInt(formValues.idExpediente);
            row.detalleExpediente = expediente.detalleExpediente;

            props.onConfirm(row);
        }
        ;
    };

    function getErrors() {

        const errors = {};

        if (formValues.numero === '') errors.numero = VALIDATION_MESSAGE.REQUIRED
        if (formValues.idMotivoInspeccion <= 0) errors.idMotivoInspeccion = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.idSupervisor <= 0) errors.idSupervisor = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.idInspector <= 0) errors.idInspector = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.anioDesde === '') errors.anioDesde = VALIDATION_MESSAGE.REQUIRED
        if (formValues.mesDesde === '') errors.mesDesde = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.anioHasta === '') errors.anioHasta = VALIDATION_MESSAGE.REQUIRED
        if (formValues.mesHasta === '') errors.mesHasta = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.numeroResolucion === '') errors.numeroResolucion = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.letraResolucion === '') errors.letraResolucion = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.anioResolucion === '') errors.anioResolucion = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.numeroLegajillo === '') errors.numeroLegajillo = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.letraLegajillo === '') errors.letraLegajillo = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.anioLegajillo === '') errors.anioLegajillo = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.activo === '') errors.activo = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.porcentajeMulta <= 0) errors.porcentajeMulta = 'Ingresá un número mayor a cero'
        if (formValues.emiteConstancia === '') errors.emiteConstancia = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.idExpediente <= 0) errors.idExpediente = VALIDATION_MESSAGE.REQUIRED_OPTION

        return errors;
    }

    const getDescTipoControlador = (id) => {
        const row = getRowTipoControlador('TipoControlador', id);
        return (row) ? row.nombre : '';
    }

    return (
        <>
            <Modal
                size="lg"
                title={`Inspección: ${(state.entity.id > 0) ? state.entity.numero : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.INSPECCION_MODAL}
                onEscape={() => props.onDismiss()}
                body={(<>
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Datos de inspección" open={datosOpen} onToggle={setDatosOpen}>
                                            <div className='row form-basic'>
                                                <div className="mb-3 col-12 col-md-6">
                                                    <FormLabel htmlFor="numero" required>Número</FormLabel>
                                                    <input
                                                        name="numero"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('numero') ? 'is-invalid' : ''}`}
                                                        value={formValues.numero}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('numero')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-6">
                                                    <FormLabel htmlFor="idMotivoInspeccion"
                                                           required>Motivo</FormLabel>
                                                    <InputLista
                                                        name="idMotivoInspeccion"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('idMotivoInspeccion') ? 'is-invalid' : ''}`}
                                                        value={formValues.idMotivoInspeccion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        lista="MotivoInspeccion"
                                                    />
                                                    <FormError message={errorOf('idMotivoInspeccion')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-6">
                                                    <FormLabel htmlFor="idSupervisor"
                                                           required>Supervisor/a</FormLabel>
                                                    <InputEntidad
                                                        name="idSupervisor"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.SUPERVISOR_MODAL}
                                                        className={`form-control ${errorOf('idSupervisor') ? 'is-invalid' : ''}`}
                                                        value={formValues.idSupervisor}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Supervisor"
                                                        entidad="Controlador"
                                                        onFormat={(row) => (row && row.id) ? (row.nombrePersona) : ''}
                                                        columns={[
                                                            {
                                                                Header: 'Tipo',
                                                                Cell: (props) => getDescTipoControlador(props.value),
                                                                accessor: 'idTipoControlador',
                                                                width: '40%'
                                                            },
                                                            {Header: 'Nombre', accessor: 'nombrePersona', width: '60%'}
                                                        ]}
                                                    />
                                                    <FormError message={errorOf('idSupervisor')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-6">
                                                    <FormLabel htmlFor="idInspector"
                                                           required>Inspector/a</FormLabel>
                                                    <InputEntidad
                                                        name="idInspector"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.INSPECTOR_MODAL}
                                                        className={`form-control ${errorOf('idInspector') ? 'is-invalid' : ''}`}
                                                        value={formValues.idInspector}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Inspector"
                                                        entidad="Controlador"
                                                        onFormat={(row) => (row && row.id) ? (row.nombrePersona) : ''}
                                                        columns={[
                                                            {
                                                                Header: 'Tipo',
                                                                Cell: (props) => getDescTipoControlador(props.value),
                                                                accessor: 'idTipoControlador',
                                                                width: '40%'
                                                            },
                                                            {Header: 'Nombre', accessor: 'nombrePersona', width: '60%'}
                                                        ]}
                                                    />
                                                    <FormError message={errorOf('idInspector')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <label htmlFor="fechaInicio" className="form-label">Fecha
                                                        inicio</label>
                                                    <DatePickerCustom
                                                        name="fechaInicio"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaInicio}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <label htmlFor="fechaFinalizacion" className="form-label">Fecha
                                                        finalización</label>
                                                    <DatePickerCustom
                                                        name="fechaFinalizacion"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaFinalizacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <label htmlFor="fechaNotificacion" className="form-label">Fecha
                                                        notificación</label>
                                                    <DatePickerCustom
                                                        name="fechaNotificacion"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaNotificacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                                    <DatePickerCustom
                                                        name="fechaBaja"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaBaja}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="mb-3 col-6">
                                                    <h3 className="modal-title">Desde:</h3>
                                                </div>
                                                <div className="mb-3 col-6 ">
                                                    <h3 className="modal-title">Hasta:</h3>
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <FormLabel htmlFor="anioDesde" required>Año</FormLabel>
                                                    <InputEjercicio
                                                        name="anioDesde"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('anioDesde') ? 'is-invalid' : ''}`}
                                                        value={formValues.anioDesde}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('anioDesde')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <label htmlFor="mesDesde" className="form-label">Mes</label>
                                                    <Select
                                                        name="mesDesde"
                                                        className={`form-control ${errorOf('mesDesde') ? 'is-invalid' : ''}`}
                                                        value={formValues.mesDesde}
                                                        options={GetMeses().map(item => ({value: item.key, label: item.name}))}
                                                        emptyOption="Sin selección"
                                                        emptyValue={0}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('mesDesde')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <FormLabel htmlFor="anioHasta" required>Año</FormLabel>
                                                    <InputEjercicio
                                                        name="anioHasta"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('anioHasta') ? 'is-invalid' : ''}`}
                                                        value={formValues.anioHasta}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('anioHasta')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <label htmlFor="mesHasta" className="form-label">Mes</label>
                                                    <Select
                                                        name="mesHasta"
                                                        className={`form-control ${errorOf('mesHasta') ? 'is-invalid' : ''}`}
                                                        value={formValues.mesHasta}
                                                        options={GetMeses().map(item => ({value: item.key, label: item.name}))}
                                                        emptyOption="Sin selección"
                                                        emptyValue={0}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('mesHasta')} />
                                                </div>
                                                <div className="mb-3 col-12 ">
                                                    <h3 className="modal-title">Resolución:</h3>
                                                </div>
                                                <div className="mb-3 col-6 col-xl-2">
                                                    <FormLabel htmlFor="numeroResolucion"
                                                           required>Número</FormLabel>
                                                    <input
                                                        name="numeroResolucion"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('numeroResolucion') ? 'is-invalid' : ''}`}
                                                        value={formValues.numeroResolucion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('numeroResolucion')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-2">
                                                    <FormLabel htmlFor="letraResolucion"
                                                           required>Letra</FormLabel>
                                                    <input
                                                        name="letraResolucion"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('letraResolucion') ? 'is-invalid' : ''}`}
                                                        value={formValues.letraResolucion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('letraResolucion')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-2">
                                                    <FormLabel htmlFor="anioResolucion" required>Año</FormLabel>
                                                    <InputEjercicio
                                                        name="anioResolucion"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('anioResolucion') ? 'is-invalid' : ''}`}
                                                        value={formValues.anioResolucion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('anioResolucion')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <label htmlFor="fechaResolucion"
                                                           className="form-label">Fecha</label>
                                                    <DatePickerCustom
                                                        name="fechaResolucion"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaResolucion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="mb-3 col-12 ">
                                                    <h3 className="modal-title">Legajillo:</h3>
                                                </div>
                                                <div className="mb-3 col-6 col-xl-2">
                                                    <FormLabel htmlFor="numeroLegajillo"
                                                           required>Número</FormLabel>
                                                    <input
                                                        name="numeroLegajillo"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('numeroLegajillo') ? 'is-invalid' : ''}`}
                                                        value={formValues.numeroLegajillo}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('numeroLegajillo')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-2">
                                                    <FormLabel htmlFor="letraLegajillo" required>Letra</FormLabel>
                                                    <input
                                                        name="letraLegajillo"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('letraLegajillo') ? 'is-invalid' : ''}`}
                                                        onChange={formHandle}
                                                        value={formValues.letraLegajillo}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('letraLegajillo')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-2">
                                                    <FormLabel htmlFor="anioLegajillo" required>Año</FormLabel>
                                                    <InputEjercicio
                                                        name="anioLegajillo"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('anioLegajillo') ? 'is-invalid' : ''}`}
                                                        value={formValues.anioLegajillo}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('anioLegajillo')} />
                                                </div>
                                                <div className="mb-3 col-6 col-xl-3">
                                                    <FormLabel htmlFor="activo" required>Activo</FormLabel>
                                                    <Select
                                                        name="activo"
                                                        className={`form-control ${errorOf('activo') ? 'is-invalid' : ''}`}
                                                        value={formValues.activo}
                                                        options={["D"].map(item => ({value: item, label: item}))}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('activo')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-4 col-xl-3">
                                                    <FormLabel htmlFor="porcentajeMulta" required>Porcentaje multa</FormLabel>
                                                    <InputPercent
                                                        name="porcentajeMulta"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('porcentajeMulta') ? 'is-invalid' : ''}`}
                                                        value={formValues.porcentajeMulta}
                                                        onChange={formHandle}
                                                        validation={(value) => value === undefined || value >= 0}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('porcentajeMulta')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4 col-xl-3">
                                                    <FormLabel htmlFor="emiteConstancia" required>Emite
                                                        constancia</FormLabel>
                                                    <Select
                                                        name="emiteConstancia"
                                                        className={`form-control ${errorOf('emiteConstancia') ? 'is-invalid' : ''}`}
                                                        value={formValues.emiteConstancia}
                                                        options={["S", "D", "C", "N", "M"].map(item => ({value: item, label: item}))}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('emiteConstancia')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <CheckboxButtonGroup label="Multa">
                                                        <CheckboxButton
                                                            name="pagaPorcentaje"
                                                            label="Paga 8%"
                                                            checked={formValues.pagaPorcentaje}
                                                            onChange={formHandle}
                                                            disabled={props.disabled}
                                                        />
                                                    </CheckboxButtonGroup>
                                                </div>
                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Vínculo expediente" open={expedienteOpen} onToggle={setExpedienteOpen}>
                                            <div className='row form-basic'>
                                                <div className="mb-3 col-12">
                                                    <FormLabel htmlFor="idExpediente" required>Vínculo
                                                        expediente</FormLabel>
                                                    <InputExpediente
                                                        name="idExpediente"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('idExpediente') ? 'is-invalid' : ''}`}
                                                        value={formValues.idExpediente}
                                                        onChange={(event) => {
                                                            const {target} = event;
                                                            const expediente = (target.row) ? {
                                                                detalleExpediente: target.row.detalleExpediente,
                                                            } : {
                                                                detalleExpediente: ""
                                                            };
                                                            setExpediente(expediente);
                                                            formHandle(event);
                                                        }}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('idExpediente')} />
                                                </div>
                                            </div>
                                    </Accordion>
                                </div>
                            </div>

                            <div className="mb-3 col-12">
                                <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de rubros comercio"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_RUBRO_COMERCIO_MODAL}
                                            processKey={props.processKey}
                                            entidad="RubroComercio"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                </Accordion>
                            </div>
                </>)}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />
        </>
    );
}

InspeccionModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

InspeccionModal.defaultProps = {
    disabled: false
};

export default InspeccionModal;
